import classNames from "classnames";
import { Tooltip } from "frontend/ui-components/floaters/tooltip";
import { useRef } from "react";
import { useHover } from "usehooks-ts";
import style from "./toggle-button.module.css";

interface ToggleButtonUniqueProps {
  isOn: boolean;
  onClick: () => void;
  tooltip?: string;
  className?: string;
}

type ToggleButtonProps = React.PropsWithChildren<ToggleButtonUniqueProps & React.ComponentPropsWithoutRef<"span">>;

export default function ToggleButton(props: ToggleButtonProps) {
  const { isOn, onClick, children, className, tooltip, ...restProps } = props;
  const clsName = classNames(style.toggleButton, className, isOn && style.selected);
  const ref = useRef<HTMLButtonElement>(null);
  const hover = useHover(ref);
  return (
    <>
      <button ref={ref} className={clsName} onClick={onClick} {...restProps}>
        {children}
      </button>
      {hover && tooltip && <Tooltip label={tooltip} relativeTo={ref} design="monday" />}
    </>
  );
}
